<template>
  <div
    class="px-4 py-16 mt-1 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20"
  >
    <div class="flex flex-col mb-6 lg:flex-row md:mb-10">
      <div class="lg:w-1/2">
        <h2
          class="max-w-md mb-6 font-sans text-3xl font-bold tracking-tight text-green-900 sm:text-4xl sm:leading-none xl:max-w-lg"
        >
          Some of the project we have worked on
        </h2>
      </div>
    </div>
    <div class="grid gap-8 row-gap-10 sm:grid-cols-2 lg:grid-cols-4">
      <div class="max-w-md">
        <div
          class="flex animate-bounce items-center justify-center w-16 h-16 mb-4 rounded-full bg-indigo-50"
        >
          <svg
            class="w-12 h-12 text-deep-purple-accent-400"
            stroke="currentColor"
            viewBox="0 0 52 52"
          >
            <polygon
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
              fill="none"
              points="29 13 14 29 25 29 23 39 38 23 27 23"
            ></polygon>
          </svg>
        </div>
        <h6 class="mb-2 animate-pulse flex space-x-4 font-semibold leading-5">
          Vegetation clearance
        </h6>
        <p class="mb-3 text-sm text-gray-900">
          Vegetation clearance/maintenance - golfcouse and within CDM (Petra
          diamonds)
        </p>
      </div>
      <div class="max-w-md">
        <div
          class="flex animate-bounce items-center justify-center w-16 h-16 mb-4 rounded-full bg-indigo-50"
        >
          <svg
            class="w-12 h-12 text-deep-purple-accent-400"
            stroke="currentColor"
            viewBox="0 0 52 52"
          >
            <polygon
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
              fill="none"
              points="29 13 14 29 25 29 23 39 38 23 27 23"
            ></polygon>
          </svg>
        </div>
        <h6 class="mb-2 animate-pulse flex space-x-4 font-semibold leading-5">
          Maintenance of vegetation
        </h6>
        <p class="mb-3 text-sm text-gray-900">
          Maintenance of vegetation around the monitoring points including the
          access route for Petra diamonds
        </p>
      </div>
      <div class="max-w-md">
        <div
          class="flex animate-bounce items-center justify-center w-16 h-16 mb-4 rounded-full bg-indigo-50"
        >
          <svg
            class="w-12 h-12 text-deep-purple-accent-400"
            stroke="currentColor"
            viewBox="0 0 52 52"
          >
            <polygon
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
              fill="none"
              points="29 13 14 29 25 29 23 39 38 23 27 23"
            ></polygon>
          </svg>
        </div>
        <h6 class="mb-2 animate-pulse flex space-x-4 font-semibold leading-5">
          Firebreak maintenance
        </h6>
        <p class="mb-3 text-sm text-gray-900">
          Firebreak maintenance (5m) near residential areas for Petra diamonds
        </p>
      </div>
      <div class="max-w-md">
        <div
          class="flex animate-bounce items-center justify-center w-16 h-16 mb-4 rounded-full bg-indigo-50"
        >
          <svg
            class="w-12 h-12 text-deep-purple-accent-400"
            stroke="currentColor"
            viewBox="0 0 52 52"
          >
            <polygon
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
              fill="none"
              points="29 13 14 29 25 29 23 39 38 23 27 23"
            ></polygon>
          </svg>
        </div>
        <h6 class="mb-2 animate-pulse flex space-x-4 font-semibold leading-5">
          storm water channel
        </h6>
        <p class="mb-3 text-sm text-gray-900">
          Cutting and removal of trees around the storm water channel for Petra
          diamonds
        </p>
      </div>
    </div>
  </div>

  <div
    class="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20"
  >
    <div class="max-w-xl mb-10 md:mx-auto sm:text-center lg:max-w-2xl md:mb-12">
      <div></div>
      <h2
        class="max-w-lg mb-6 font-sans text-3xl font-bold leading-none tracking-tight text-green-900 sm:text-4xl md:mx-auto"
      >
        <span class="relative inline-block">
          <svg
            viewBox="0 0 52 24"
            fill="currentColor"
            class="absolute top-0 left-0 z-0 hidden w-32 -mt-8 -ml-20 text-blue-gray-100 lg:w-32 lg:-ml-28 lg:-mt-10 sm:block"
          >
            <defs>
              <pattern
                id="9a29985a-fc16-419b-ae53-1670f5ca4491"
                x="0"
                y="0"
                width=".135"
                height=".30"
              >
                <circle cx="1" cy="1" r=".7"></circle>
              </pattern>
            </defs>
            <rect
              fill="url(#9a29985a-fc16-419b-ae53-1670f5ca4491)"
              width="52"
              height="24"
            ></rect>
          </svg>
          <span class="relative">The</span>
        </span>
        Environmental awareness
      </h2>
      <p class="text-base text-gray-700 md:text-lg">
        prevention of degradation of the landscape and ecosystems
      </p>
    </div>
    <div
      class="grid max-w-screen-lg gap-8 row-gap-5 mb-8 sm:grid-cols-2 lg:grid-cols-4 sm:mx-auto"
    >
      <img
        class="object-cover transition duration-500 ease-in-out transform hover:-translate-y-1 w-full h-56 rounded shadow-lg"
        src="https://images.pexels.com/photos/3401354/pexels-photo-3401354.jpeg?auto=compress&amp;cs=tinysrgb&amp;dpr=2&amp;h=750&amp;w=1260"
        alt=""
      />
      <img
        class="object-cover transition duration-500 ease-in-out transform hover:-translate-y-1 w-full h-56 rounded shadow-lg"
        src="https://images.pexels.com/photos/929385/pexels-photo-929385.jpeg?auto=compress&amp;cs=tinysrgb&amp;dpr=2&amp;h=750&amp;w=1260"
        alt=""
      />
      <img
        class="object-cover transition duration-500 ease-in-out transform hover:-translate-y-1 w-full h-56 rounded shadow-lg"
        src="https://images.pexels.com/photos/4394372/pexels-photo-4394372.jpeg?auto=compress&amp;cs=tinysrgb&amp;dpr=2&amp;w=500"
        alt=""
      />
      <img
        class="object-cover transition duration-500 ease-in-out transform hover:-translate-y-1 w-full h-56 rounded shadow-lg"
        src="https://images.pexels.com/photos/6045858/pexels-photo-6045858.jpeg?auto=compress&amp;cs=tinysrgb&amp;dpr=2&amp;h=750&amp;w=1260"
        alt=""
      />
    </div>
    <div class="flex items-center sm:justify-center"></div>
  </div>

  <section class="dark:bg-coolGray-800 dark:text-coolGray-100">
    <div
      class="container max-w-xl p-6 py-12 mx-auto space-y-24 lg:px-8 lg:max-w-7xl"
    >
      <div>
        <h2
          class="text-3xl font-bold tracking-tight text-center sm:text-5xl dark:text-green-900"
        >
          Global Warming and Climate Change
        </h2>
        <p
          class="max-w-3xl mx-auto mt-4 text-sm text-left dark:text-coolGray-400"
        >
          We can all work together to make the world a better environment for
          all humankind
        </p>
      </div>
      <div class="grid lg:gap-8 lg:grid-cols-2 lg:items-center">
        <div>
          <h3
            class="text-2xl font-bold tracking-tight sm:text-3xl dark:text-coolGray-50"
          >
            Natural causes of climate change
          </h3>
          <p class="mt-3 text-lg dark:text-coolGray-400">
            The earth has gone through warming and cooling phases in the past,
            long before humans were around
          </p>
          <div class="mt-12 space-y-12">
            <div class="flex">
              <div class="flex-shrink-0">
                <div
                  class="flex transition duration-500 ease-in-out transform hover:-translate-y-1 items-center justify-center w-12 h-12 rounded-md dark:bg-violet-400 dark:text-coolGray-900"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    class="w-7 h-7"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M5 13l4 4L19 7"
                    ></path>
                  </svg>
                </div>
              </div>
              <div class="ml-4">
                <h4 class="text-lg font-medium leading-6 dark:text-coolGray-50">
                  Anthropogenic causes of climate change
                </h4>
                <p class="mt-2 dark:text-coolGray-400">
                  Humans—more specifically, the greenhouse gas (GHG) emissions
                  that human activity generates—are the leading cause of the
                  earth’s rapidly changing climate today.
                </p>
              </div>
            </div>
            <div class="flex">
              <div class="flex-shrink-0">
                <div
                  class="flex transition duration-500 ease-in-out transform hover:-translate-y-1 items-center justify-center w-12 h-12 rounded-md dark:bg-violet-400 dark:text-coolGray-900"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    class="w-7 h-7"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M5 13l4 4L19 7"
                    ></path>
                  </svg>
                </div>
              </div>
              <div class="ml-4">
                <h4 class="text-lg font-medium leading-6 dark:text-coolGray-50">
                  Air pollution
                </h4>
                <p class="mt-2 dark:text-coolGray-400">
                  Air pollution and climate change are inextricably linked, with
                  one exacerbating the other. When the earth’s temperatures
                  rise, not only does our air get dirtier—with smog and soot
                  levels rising accordingly—but it also becomes filled with more
                  allergenic pollutants, such as circulating mold (thanks to
                  damp conditions from extreme weather and more floods) and
                  pollen (due to longer, stronger pollen seasons).
                </p>
              </div>
            </div>
            <div class="flex">
              <div class="flex-shrink-0">
                <div
                  class="flex transition duration-500 ease-in-out transform hover:-translate-y-1 items-center justify-center w-12 h-12 rounded-md dark:bg-violet-400 dark:text-coolGray-900"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    class="w-7 h-7"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M5 13l4 4L19 7"
                    ></path>
                  </svg>
                </div>
              </div>
              <div class="ml-4">
                <h4 class="text-lg font-medium leading-6 dark:text-coolGray-50">
                  Climate Change Solutions
                </h4>
                <p class="mt-2 dark:text-coolGray-400">
                  We can mitigate global climate change and help stem its
                  detrimental impacts, but doing so will require tackling its
                  root cause: pollution from burning fossil fuels.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div aria-hidden="true" class="mt-10 lg:mt-0">
          <img
            src="https://source.unsplash.com/random/360x480"
            alt=""
            class="mx-auto transition duration-500 ease-in-out transform hover:-translate-y-1 rounded-lg shadow-lg dark:bg-coolGray-500"
          />
        </div>
      </div>
      <div>
        <div class="grid lg:gap-8 lg:grid-cols-2 lg:items-center">
          <div class="lg:col-start-2">
            <h3
              class="text-2xl font-bold tracking-tight sm:text-3xl dark:text-coolGray-50"
            >
              Examples of Environmental Issues
            </h3>
            <p class="mt-3 text-lg dark:text-coolGray-400">
              Here are several cause-and-effect problems that harm our
              environment.
            </p>
            <div class="mt-12 space-y-12">
              <div class="flex">
                <div class="flex-shrink-0">
                  <div
                    class="flex transition duration-500 ease-in-out transform hover:-translate-y-1 items-center justify-center w-12 h-12 rounded-md dark:bg-violet-400 dark:text-coolGray-900"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      class="w-7 h-7"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M5 13l4 4L19 7"
                      ></path>
                    </svg>
                  </div>
                </div>
                <div class="ml-4">
                  <h4
                    class="text-lg font-medium leading-6 dark:text-coolGray-50"
                  >
                    Oil Drilling
                  </h4>
                  <p class="mt-2 dark:text-coolGray-400">
                    This issue is one that causes a great deal of environmental
                    destruction. Our dependence on fossil fuel is a global
                    addiction that affects every aspect of the world. Oil spills
                    and offshore drilling poison marine life, oil drilling (on
                    land) suffocates the earth, and the combustion of fossil
                    fuels add to the increased atmospheric CO₂, which in turns
                    causes the progression of global warming and ocean
                    acidification.
                  </p>
                </div>
              </div>
              <div class="flex">
                <div class="flex-shrink-0">
                  <div
                    class="flex transition duration-500 ease-in-out transform hover:-translate-y-1 items-center justify-center w-12 h-12 rounded-md dark:bg-violet-400 dark:text-coolGray-900"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      class="w-7 h-7"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M5 13l4 4L19 7"
                      ></path>
                    </svg>
                  </div>
                </div>
                <div class="ml-4">
                  <h4
                    class="text-lg font-medium leading-6 dark:text-coolGray-50"
                  >
                    Deforestation
                  </h4>
                  <p class="mt-2 dark:text-coolGray-400">
                    Millions of acres of forest are cut down for industrial
                    benefit, such as large scale farming, oil mining, and the
                    production of paper goods. Deforestation causes wildlife and
                    biodiversity extinction because the loss of habitat
                    threatens many species’ existence.
                  </p>
                </div>
              </div>
              <div class="flex">
                <div class="flex-shrink-0">
                  <div
                    class="flex transition duration-500 ease-in-out transform hover:-translate-y-1 items-center justify-center w-12 h-12 rounded-md dark:bg-violet-400 dark:text-coolGray-900"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      class="w-7 h-7"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M5 13l4 4L19 7"
                      ></path>
                    </svg>
                  </div>
                </div>
                <div class="ml-4">
                  <h4
                    class="text-lg font-medium leading-6 dark:text-coolGray-50"
                  >
                    Production of Plastic Goods
                  </h4>
                  <p class="mt-2 dark:text-coolGray-400">
                    Currently our society creates a great deal of waste and much
                    of that waste consists of plastic. According to the
                    Environmental Protection Agency (EPA) in 2010 alone 31
                    million tons of plastic waste was created
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            class="mt-10 transition duration-500 ease-in-out transform hover:-translate-y-1 lg:mt-0 lg:col-start-1 lg:row-start-1"
          >
            <img
              src="https://source.unsplash.com/random/361x481"
              alt=""
              class="mx-auto rounded-lg shadow-lg dark:bg-coolGray-500"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
